import { render, staticRenderFns } from "./WYSIWYG2.vue?vue&type=template&id=598b3c53"
import script from "./WYSIWYG2.vue?vue&type=script&lang=js"
export * from "./WYSIWYG2.vue?vue&type=script&lang=js"
import style0 from "./WYSIWYG2.vue?vue&type=style&index=0&id=598b3c53&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports